export default "__VITE_ASSET__BFDVUVUS__";